import PolicyComp from "../components/policy_component/Policy";

const PolicyP = () => {
    return ( 
        <>
        <PolicyComp/>
        </>
     );
}
 
export default PolicyP;